import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Globe } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, meta, languages } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-white/80 hover:text-white transition-colors text-sm"
        aria-label="Change language"
      >
        {compact ? <Globe className="w-5 h-5" /> : <span className="text-base leading-none">{meta.flag}</span>}
        {!compact && <span className="font-cond tracking-wide uppercase">{lang}</span>}
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-3 w-52 rounded-xl border border-white/10 bg-[#0a0a0a]/95 backdrop-blur-xl shadow-2xl overflow-hidden z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-white/5 transition-colors ${lang === l.code ? 'text-white' : 'text-white/60'}`}
            >
              <span className="text-base">{l.flag}</span>
              <span className="flex-1 text-left">{l.label}</span>
              {lang === l.code && <span className="w-1.5 h-1.5 rounded-full bg-[#ff2d2d]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
